module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1409-retro-min.17c7afd4.jpg";